module.exports = __webpack_public_path__ + "static/element-no-padding-a2012682566db5391f71375cb931e439.mp4";